import dayjs from "dayjs"
// $cache startDate/endDate 默认值
let startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD'),
    expire = dayjs(dayjs().add(1, 'day').format("YYYY-MM-DD")).diff(dayjs(), 's')

export default {
    // base
    "api/admin/sys/position/index": {
        meta: {
            title: '岗位管理'
        },
        name: "position",
        component: () =>
            import('_v/admin/sys/position/index')
    },
    "api/admin/sys/dict/index": {
        meta: {
            title: '词典管理'
        },
        name: "dict",
        component: () =>
            import('_v/admin/sys/dict/index')
    },
    "api/admin/sys/resource/index": {
        meta: {
            title: '资源管理'
        },
        component: () =>
            import('_v/admin/sys/resource/index')
    },
    "api/admin/sys/user/index": {
        meta: {
            title: '用户管理'
        },
        name: "user",
        component: () =>
            import('_v/admin/sys/user/index')
    },
    "api/admin/sys/auth/index": {
        meta: {
            title: '权限管理',
        },
        path: 'authResources',
        name: 'authResources',
        component: () =>
            import('_v/admin/sys/position/auth')
    },
    "api/sell/notify/index": {
        meta: {
            title: "公告广告"
        },
        name: "notifyIndex",
        component: () =>
            import('_v/notify-manage/index'),
        children: {
            "api/sell/message/index": {
                meta: {
                    title: "消息公告",
                },
                name: "messageIndex",
                component: () =>
                    import('_v/notify-manage/message/index')
            },
            "api/sell/notice/index": {
                meta: {
                    title: "广告设置",
                },
                name: "noticeIndex",
                component: () =>
                    import('_v/notify-manage/notice/index')
            }
        }
    },
    "api/proj/info/index": {
        meta: {
            title: '项目管理',
        },
        path: 'projManage',
        name: 'projManage',
        component: () =>
            import('_v/proj-manage/index'),
        children: {
            "api/proj/base/index": {
                meta: {
                    title: "基本信息",
                },
                name: "projBase",
                component: () =>
                    import('_v/proj-manage/detail/proj-info')
            },
            "api/proj/img/index": {
                meta: {
                    title: "项目图片",
                },
                name: "projImg",
                component: () =>
                    import('_v/proj-manage/detail/proj-img')
            },
            "api/proj/house/index": {
                meta: {
                    title: "户型管理",
                },
                name: "projHouse",
                component: () =>
                    import('_v/proj-manage/detail/proj-house')
            },
            "api/proj/floor/index": {
                meta: {
                    title: "楼栋管理",
                },
                name: "projFloor",
                component: () =>
                    import('_v/proj-manage/detail/proj-floor')
            },
            "api/proj/source/index": {
                meta: {
                    title: "房源管理",
                },
                name: "projSource",
                component: () =>
                    import('_v/proj-manage/detail/proj-source')
            },

        },
    },
    "api/activity/manage/index": {
        meta: {
            title: '活动管理',
        },
        path: 'activityManage',
        name: 'activityManage',
        component: () =>
            import('_v/activity-manage/index')
    },
    "api/customer/dynamic/index": {
        meta: {
            title: '客户动态',
            cache: {
                // 租户代码
                projId: {
                    defaultVal: '', // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                }
            },
        },
        path: 'customerDynamic',
        name: 'customerDynamic',
        component: () =>
            import('_v/customer-dynamic/index'),
        children: {
            "api/customer/wechat/index": {
                meta: {
                    title: "微信客户",
                },
                name: "cusWeChat",
                component: () =>
                    import('_v/customer-dynamic/weChat-list')
            },
            "api/customer/register/index": {
                meta: {
                    title: "预约登记",
                },
                name: "cusRegister",
                component: () =>
                    import('_v/customer-dynamic/notice-list')
            },
            "api/customer/price/index": {
                meta: {
                    title: "变价通知",
                },
                name: "cusPrice",
                component: () =>
                    import('_v/customer-dynamic/notice-list')
            },
            "api/customer/notice/index": {
                meta: {
                    title: "开盘通知",
                },
                name: "cusNotice",
                component: () =>
                    import('_v/customer-dynamic/notice-list')
            },
        }
    },
    "api/order/info/index": {
        meta: {
            title: '订单查询',
            cache: {
                projId: {
                    defaultVal: '', // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                }
            },
        },
        path: 'orderInfo',
        name: 'orderInfo',
        component: () =>
            import('_v/order-info/index'),
    },
    "api/bill/info/index": {
        meta: {
            title: '账单查询',
            cache: {
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                }
            },
        },
        path: 'billInfo',
        name: 'billInfo',
        component: () =>
            import('_v/bill-info/index'),
    },
    "api/wx/integral/index": {
        meta: {
            title: '积分查询',
        },
        name: 'wxIntegral',
        component: () =>
            import('_v/wx-integral/index'),
    },
    "api/mall/info/index": {
        meta: {
            title: '积分商城',
        },
        name: 'mallInfo',
        component: () =>
            import('_v/mall-info/index'),
        children: {
            "api/mall/goods/index": {
                meta: {
                    title: "商品管理",
                },
                name: "mallGoodsIndex",
                component: () =>
                    import('_v/mall-info/goods/list-goods')
            },
            "api/mall/order/index": {
                meta: {
                    title: "订单管理",
                },
                name: "mallOrderIndex",
                component: () =>
                    import('_v/mall-info/order/list-order')
            }
        }
    },
    "api/sell/statistic/index": {
        meta: {
            title: '营销分析',
        },
        name: 'sellStatistic',
        component: () =>
            import('_v/sell-statistic/index'),
    },
    "api/broker/manage/index": {
        meta: {
            title: '经纪管理',
        },
        name: 'brokerManage',
        component: () =>
            import('_v/broker-manage/list-broker'),
    },
    "api/customer/account/index": {
        meta: {
            title: '客户台账',
        },
        name: 'customerAccount',
        component: () =>
            import('_v/customer-account/list-customer'),
    },
    "api/rule/manage/index": {
        meta: {
            title: '规则管理',
        },
        name: 'ruleManage',
        component: () =>
            import('_v/rule-manage/list-rule'),
    },
    "api/customer/recommend/index": {
        meta: {
            title: '客户推荐',
            cache: {
                // 租户代码
                projId: {
                    defaultVal: '', // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                currentTab: {
                    defaultVal: "cusReport", // 默认值
                    expire: expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        path: 'customerRecommend',
        name: 'customerRecommend',
        component: () =>
            import('_v/customer-recommend/recommend-index'),
        children: {
            "api/recommend/report/customer/index": {
                meta: {
                    title: "报备客户",
                },
                name: "cusReport",
                component: () =>
                    import('_v/customer-recommend/list-recommend')
            },
            "api/recommend/visit/customer/index": {
                meta: {
                    title: "到访客户",
                },
                name: "cusVisit",
                component: () =>
                    import('_v/customer-recommend/list-recommend')
            },
            "api/recommend/finish/customer/index": {
                meta: {
                    title: "成交客户",
                },
                name: "cusFinish",
                component: () =>
                    import('_v/customer-recommend/list-recommend')
            },
            "api/recommend/windup/customer/index": {
                meta: {
                    title: "结佣客户",
                },
                name: "cusWindup",
                component: () =>
                    import('_v/customer-recommend/list-recommend')
            },
        }
    },
}
